import { ViewModelService } from 'src/app/shared/view-model.service';
import { BaseProps, BaseViewModelBase } from 'src/store/generated/base-record.generated';
import { CompanyViewModel } from './company-view-model';
import { LocationViewModel } from './location-view-model';

export class BaseViewModel extends BaseViewModelBase {
  constructor(
    base: BaseProps,
    public readonly location: LocationViewModel,
    public readonly company: CompanyViewModel,
    public readonly aviationCompany: CompanyViewModel | undefined,
    public readonly dispatchBase: BaseViewModel | undefined,
    public readonly reportBase: BaseViewModel | undefined,
    _model: ViewModelService,
  ) {
    super(base);
  }
}
